import React from 'react';
import { Field } from 'redux-form';
import { Button } from 'components/Base';
// import Icons from 'components/Icons';
import Fields from 'components/Fields';
import { TableRow } from '@material-ui/core';
import Router from 'components/Router/Router';
import { MetaType } from 'store/modules/Meta/types';
import { CustomerType } from 'store/modules/Customers/types';
import TableComponents from 'components/Table';
import StoreProvider from 'store/store';
// import api from 'api';
import { formatCurrency, formatPercent } from 'utils';

const { connect, selectors, actions } = StoreProvider;
const { useHistory, useParams } = Router;

interface RecommendedPolicyProps {
  policyTypes: MetaType;
  policyProviders: MetaType;
  policyPlatforms: MetaType;
  customers: Array<CustomerType>;
  policyValues: any;
  field: string;
  getRecommendationsData: any;
  isEvalue: boolean;
}
const RecommendedPolicy = ({
  policyTypes,
  policyProviders,
  policyPlatforms,
  customers,
  policyValues,
  field,
  isEvalue
}: // getRecommendationsData,
RecommendedPolicyProps) => {
  // const [isProcessing, setIsProcessing] = useState(false);
  const history = useHistory();
  const { portfolio } = useParams() as any;

  const { haveFunds, annualised_contribution, annualised_withdrawal } =
    policyValues;
  // TODO UNCOMMIT WHEN BE IS READY FOR REMOVING POLICY

  // const removePolicy = (id?: string) => {
  //   if (!id) return;
  //   setIsProcessing(true);
  //   return api
  //     .removePolicy({ policyId: id, portfolio: portfolio })
  //     .then(() => {
  //       getRecommendationsData({ portfolio }).then(() =>
  //         setIsProcessing(false)
  //       );
  //     })
  //     .catch(() => {
  //       setIsProcessing(false);
  //     });
  // };

  return (
    <TableRow>
      <TableComponents.TableCell width="140px">
        <Button
          id={`add-funds-${policyValues.number}`}
          style={{
            backgroundColor: haveFunds && '#039700',
            padding: '9px 15px'
          }}
          onClick={() =>
            history.push(
              `/${portfolio}/recommendations/portfolio-builder/${policyValues.id}`
            )
          }
        >
          Manage Policy
        </Button>
      </TableComponents.TableCell>
      <TableComponents.TableCell>
        <Field
          name={`${field}.owner`}
          fullWidth
          validate={Fields.Validators.required}
          displayEmpty
          options={customers.map((customer: CustomerType) => {
            return {
              name: customer.display_name,
              value: customer.id
            };
          })}
          component={Fields.String}
        />
      </TableComponents.TableCell>
      <TableComponents.TableCell>
        <Field
          name={`${field}.number`}
          fullWidth
          disabled
          component={Fields.String}
        />
      </TableComponents.TableCell>
      <TableComponents.TableCell>
        <Field
          name={`${field}.platform`}
          fullWidth
          disabled
          options={policyPlatforms}
          component={Fields.String}
        />
      </TableComponents.TableCell>
      <TableComponents.TableCell>
        <Field
          name={`${field}.provider`}
          fullWidth
          displayEmpty
          options={policyProviders}
          component={Fields.String}
        />
      </TableComponents.TableCell>
      <TableComponents.TableCell>
        <Field
          name={`${field}.type`}
          fullWidth
          displayEmpty
          options={policyTypes}
          component={Fields.String}
        />
      </TableComponents.TableCell>
      <TableComponents.TableCell>
        <Field
          name={`${field}.fund_value_initial`}
          fullWidth
          format={(val: any) => formatCurrency(val)}
          validate={Fields.Validators.required}
          component={Fields.String}
          placeholder="Fund Value"
        />
      </TableComponents.TableCell>
      <TableComponents.TableCell>
        {formatCurrency(annualised_contribution)}
      </TableComponents.TableCell>
      <TableComponents.TableCell>
        {formatCurrency(annualised_withdrawal)}
      </TableComponents.TableCell>

      <TableComponents.TableCell>
        <Field
          name={`${field}.total_ongoing_charge`}
          fullWidth
          format={(val: any) => {
            if (!val) return '-';
            return formatPercent(val);
          }}
          validate={Fields.Validators.required}
          component={Fields.String}
        />
      </TableComponents.TableCell>
      {isEvalue ? (
        <TableComponents.TableCell>
          <Field
            name={`${field}.risk_score`}
            fullWidth
            format={(val: any) => {
              if (!val) return '-';
              return val;
            }}
            validate={Fields.Validators.required}
            component={Fields.String}
          />
        </TableComponents.TableCell>
      ) : (
        <>
          <TableComponents.TableCell>
            {formatPercent(policyValues.morningstar_risk_analysis.growth_score)}
          </TableComponents.TableCell>
          <TableComponents.TableCell>
            {`${policyValues.morningstar_risk_analysis.range?.low} - ${policyValues.morningstar_risk_analysis.range?.high}`}
          </TableComponents.TableCell>
        </>
      )}
      {/* TODO Enable when api will be rdy for deleting policy, add policy ID to func */}

      {/* <TableComponents.TableCell>
        <Icons.LoadingWrapper isLoading={isProcessing}>
          <Tooltip title="Delete policy" arrow>
            <div>
              <Icons.Delete onClick={() => removePolicy()} />
            </div>
          </Tooltip>
        </Icons.LoadingWrapper>
      </TableComponents.TableCell> */}

      <TableComponents.TableCell>
        <Field
          name={`${field}.pid`}
          fullWidth
          disabled
          component={Fields.String}
        />
      </TableComponents.TableCell>
    </TableRow>
  );
};

export default connect(
  (state: any) => ({
    policyTypes: selectors.metaSelectors.policyTypes(state),
    policyProviders: selectors.metaSelectors.policyProviders(state),
    policyPlatforms: selectors.metaSelectors.policyPlatforms(state),
    customers: selectors.customersSelectors.customers(state)
  }),
  {
    getRecommendationsData: actions.recommendationActions.getRecommendationData
  }
)(RecommendedPolicy);
